/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { CarrierOptionDetailsFragmentDoc } from './CarrierOptionDetailsFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type ICarrierOptionDetailsQueryVariables = Types.Exact<{
  optionId: Types.Scalars['ID']
}>

export type ICarrierOptionDetailsQuery = { __typename?: 'Query' } & {
  bid: { __typename?: 'Bid' } & Pick<
    Types.IBid,
    | 'id'
    | 'acceptedAt'
    | 'amount'
    | 'carrierContactName'
    | 'carrierContactPhone'
    | 'carrierContactPhoneExt'
    | 'carrierContactUserId'
    | 'createdAt'
    | 'declineReason'
    | 'rateCoachGrade'
    | 'shipmentId'
    | 'source'
    | 'sourceChannel'
    | 'sourceSegment'
    | 'status'
    | 'updatedAt'
  > & {
      acceptedBy?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
      carrierApplication?: Types.Maybe<
        { __typename?: 'CarrierApplication' } & Pick<
          Types.ICarrierApplication,
          'id' | 'dotNumber' | 'mcNumber' | 'name' | 'state'
        > & {
            primaryCarrierManager?: Types.Maybe<
              { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
            >
          }
      >
      carrierContactUser?: Types.Maybe<
        { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName' | 'email'>
      >
      counterBid?: Types.Maybe<
        { __typename?: 'Bid' } & Pick<
          Types.IBid,
          | 'id'
          | 'acceptedAt'
          | 'amount'
          | 'carrierContactPhone'
          | 'carrierContactPhoneExt'
          | 'status'
          | 'shipmentId'
        >
      >
      createdBy: { __typename?: 'User' } & Pick<
        Types.IUser,
        'id' | 'parentUserId' | 'fullName' | 'email'
      >
      latestBidApproval?: Types.Maybe<
        { __typename?: 'BidApproval' } & Pick<Types.IBidApproval, 'id' | 'state' | 'updatedAt'> & {
            updatedBy?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
          }
      >
      relatedOptions: Array<
        { __typename?: 'Bid' } & Pick<Types.IBid, 'id' | 'amount' | 'createdAt' | 'status'> & {
            carrierApplication?: Types.Maybe<
              { __typename?: 'CarrierApplication' } & Pick<
                Types.ICarrierApplication,
                'id' | 'name' | 'state'
              >
            >
            createdBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
          }
      >
      shipment: { __typename?: 'Shipment' } & Pick<Types.IShipment, 'id' | 'state'> & {
          firstPickup: { __typename?: 'ShipmentStop' } & Pick<
            Types.IShipmentStop,
            'id' | 'city' | 'stateCode'
          >
          lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
            Types.IShipmentStop,
            'id' | 'city' | 'stateCode'
          >
          bouncedCarrierAssignments: Array<
            { __typename?: 'CarrierAssignment' } & Pick<
              Types.ICarrierAssignment,
              'id' | 'bouncedAt'
            > & {
                bouncedBy?: Types.Maybe<
                  { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>
                >
                carrierApplication: { __typename?: 'CarrierApplication' } & Pick<
                  Types.ICarrierApplication,
                  'id'
                >
              }
          >
          carrierManager?: Types.Maybe<
            { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
          >
        }
    }
}

export const CarrierOptionDetailsDocument = gql`
  query CarrierOptionDetails($optionId: ID!) {
    bid(id: $optionId) {
      id
      ...CarrierOptionDetails
    }
  }
  ${CarrierOptionDetailsFragmentDoc}
`

/**
 * __useCarrierOptionDetailsQuery__
 *
 * To run a query within a React component, call `useCarrierOptionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarrierOptionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarrierOptionDetailsQuery({
 *   variables: {
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useCarrierOptionDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICarrierOptionDetailsQuery,
    ICarrierOptionDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICarrierOptionDetailsQuery, ICarrierOptionDetailsQueryVariables>(
    CarrierOptionDetailsDocument,
    options
  )
}
export function useCarrierOptionDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICarrierOptionDetailsQuery,
    ICarrierOptionDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICarrierOptionDetailsQuery, ICarrierOptionDetailsQueryVariables>(
    CarrierOptionDetailsDocument,
    options
  )
}
export type CarrierOptionDetailsQueryHookResult = ReturnType<typeof useCarrierOptionDetailsQuery>
export type CarrierOptionDetailsLazyQueryHookResult = ReturnType<
  typeof useCarrierOptionDetailsLazyQuery
>
export type CarrierOptionDetailsQueryResult = Apollo.QueryResult<
  ICarrierOptionDetailsQuery,
  ICarrierOptionDetailsQueryVariables
>
